import {Component, OnInit, ViewChild} from '@angular/core';
import {UserContextService} from '../../../../core/services/user-context.service';
import {TrackingCalledSectionDashboardEnum} from '../../enums/tracking-called-section-dashboard.enum';
import {CredentialsModalComponent} from '../../../../shared/components/credentials-modal-component/credentials-modal.component';
import {ServicesApprovalService} from '../../../service/services/services-approval.service';
import {SecFEPermissionPartnerAppEnum} from '../../../../shared/enums/sec-f-e-permission-partner-app-enum';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.page.html',
    styleUrls: ['./dashboard.page.scss']
})
export class DashboardComponent implements OnInit {


    // public isSalesConcierge = false;
    protected readonly SecFEPermissionPartnerAppEnum = SecFEPermissionPartnerAppEnum;

    public TrackingCalledSectionDashboardEnum = TrackingCalledSectionDashboardEnum;

    @ViewChild(CredentialsModalComponent, {static: true}) credentialsModal: CredentialsModalComponent;


    // public gAuthData = {} as GroupAuthorizationDataModel;

    constructor(
        public userContextService: UserContextService,
        private servicesApprovalService: ServicesApprovalService,
    ) {
    }

    async ngOnInit() {
        // console.log('DashboardComponent init');
        // // update cadoozPoints when openning dashboard
        // try {
        //
        //     await this.userContext.reloadUserDetails();
        //     if (!this.credentialsManager.hasCredentials()) {
        //         this.credentialsModal.open();
        //     }
        // } finally {
        // }

        // this.gAuthData = this.groupAuthorizationService.getAuthorizationData();

    }

    // async onHtmlItemClicked(itemId?: TrackingCalledSectionDashboardEnum) {
    //     const id = TrackingCalledSectionDashboardEnum[itemId];
    //     // console.log('[H]', id);
    //     if (id) {
    //         try {
    //             await this.trackingService.createTrackingEvent(id, new Date());
    //         } catch (e) {
    //             console.error(e);
    //         }
    //
    //     } else {
    //         console.warn('unknown tracking id', itemId);
    //     }
    // }

    async onServiceBoxClick(secureLink: HTMLAnchorElement) {
        console.log('onServiceBoxClick');

        if (await this.servicesApprovalService.areServicesApproved()) {
            console.log('onServiceBoxClick in');

            secureLink.href = 'https://service.brother.co.jp/training/all/index.html?area=eu';
            secureLink.click();
            setTimeout(() => {
                secureLink.href = '';
            }, 100);
        } else {
            this.servicesApprovalService.showModalAgreementNotConfirmedInfo();
        }
    }


}
